<template>
    <a class="card-title-help dyor-logo"
        target="_blank"
        v-bind:href="link"
        v-on:mouseenter="tooltipShow"
        v-on:mouseleave="tooltipVisible = false"
    >
        <ui-tooltip
            v-bind:value="$t('jetton_filters.dyor.data_from')"
            position="top"
            v-if="tooltipVisible"
            style="top: -28px"
        />
        <dyor-logo />
    </a>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import DyorLogo from '@img/advertise/logos/dyor-symbol.svg?inline';

export default {
    props: {
        address: {
            type: String,
        },
    },

    data() {
        return {
            tooltipVisible: false,
        };
    },

    computed: {
        link() {
            if (!this.address) return 'https://dyor.io/';
            return 'https://dyor.io/token/' + this.address;
        },
    },

    methods: {
        tooltipShow() {
            if (!this.isMobile && !this.isTablet) {
                this.tooltipVisible = true;
            }
        },
    },

    components: {
        DyorLogo,
    },
};
</script>

<style scoped lang="scss">
.dyor-logo {
    position: relative;
    //display: block;
    margin-right: 10px;
    color: var(--body-muted-text-color);

    svg {
        width: 32px;
        height: 32px;
    }
}
</style>
